import { render, staticRenderFns } from "./IconSelectorModal.vue?vue&type=template&id=1a6b5dcc&"
import script from "./IconSelectorModal.vue?vue&type=script&lang=js&"
export * from "./IconSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports